import { LoggingPort } from '../ports'
import { createLoggingService } from '@otto-ec/eprivacy-measures'
import { SERVICE, TEAM } from '../model/contants'
export type { LoggingPort } from '../ports'

export const logger: LoggingPort = createLoggingService(TEAM, SERVICE)
